import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Tab } from '@headlessui/react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { SubscriptionProvider } from '../../contexts/SubscriptionContext';
import PaymentMethodsManager from './PaymentMethodsManager';
import SubscriptionManager from './SubscriptionManager';
import CreditPurchase from './CreditPurchase';

// Initialize Stripe with the publishable key
const stripePromise = loadStripe(`${process.env.STRIPE_PUBLISHABLE_KEY}`);

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

const PaymentDashboard = () => {
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState(0);

  const tabs = [
    { name: t('payment.subscriptions'), component: SubscriptionManager },
    { name: t('payment.credits'), component: CreditPurchase },
    { name: t('payment.paymentMethods'), component: PaymentMethodsManager }
  ];

  return (
    <div className="container mx-auto px-4 py-8 max-w-6xl">
      <h1 className="text-3xl font-bold mb-8">{t('payment.dashboard')}</h1>
      
      <SubscriptionProvider>
        <Elements stripe={stripePromise}>
          <Tab.Group selectedIndex={selectedTab} onChange={setSelectedTab}>
            <Tab.List className="flex space-x-1 rounded-xl bg-blue-900/10 p-1">
              {tabs.map((tab, index) => (
                <Tab
                  key={index}
                  className={({ selected }) =>
                    classNames(
                      'w-full rounded-lg py-2.5 text-sm font-medium leading-5',
                      'ring-white ring-opacity-60 ring-offset-2 ring-offset-blue-400 focus:outline-none focus:ring-2',
                      selected
                        ? 'bg-white text-blue-700 shadow'
                        : 'text-blue-500 hover:bg-white/[0.12] hover:text-blue-600'
                    )
                  }
                >
                  {tab.name}
                </Tab>
              ))}
            </Tab.List>
            <Tab.Panels className="mt-6">
              {tabs.map((tab, index) => (
                <Tab.Panel
                  key={index}
                  className={classNames(
                    'rounded-xl bg-white p-6',
                    'ring-white ring-opacity-60 ring-offset-2 ring-offset-blue-400 focus:outline-none'
                  )}
                >
                  {React.createElement(tab.component)}
                </Tab.Panel>
              ))}
            </Tab.Panels>
          </Tab.Group>
        </Elements>
      </SubscriptionProvider>
    </div>
  );
};

export default PaymentDashboard;
